whalewisdom.Subsidiary = {
  subsidiaries: [],
  init: function () {
    // listen for changes to subsidiary quarter and change subsidiary list appropriately
    /* if (!whalewisdom.Subsidiary || !whalewisdom.Subsidiary.subsidiaries || whalewisdom.Subsidiary.subsidiaries.length==0){
            jQuery('#li_subsidiary_tab_link').hide();
            jQuery('#subsidiary_tab').hide();
            return;
        } */
    var container = jQuery('#subsidiary_container')
    if (container.length == 0) {
      jQuery('#li_subsidiary_tab_link').hide()
      jQuery('#subsidiary_tab').hide()
      return
    }
    jQuery('#cmd-subsidiary-refresh').click(whalewisdom.Subsidiary.refresh)
    jQuery('#subsidiary_quarter').change(whalewisdom.Subsidiary.quarter_change)

    jQuery('#subsidiary_quarter2').change(whalewisdom.Subsidiary.quarter_change)
    jQuery('#cmd-export-subsidiary').click(whalewisdom.Subsidiary.export_excel)
    whalewisdom.Subsidiary.setup_table()

    // jQuery('#subsidiary_quarter').val(whalewisdom.Filer.current_quarter_id);
    // whalewisdom.Subsidiary.quarter_change();
  },

  quarter_change: function () {
    // jQuery('#subsidiary-list').html();
    // jQuery('#subsidiary-list2').html();
    var quarterlist = jQuery(this)
    var subsidiary_list = quarterlist.parent().find('.subsidiary')
    subsidiary_list.html('')
    // jQuery('#subsidiary-list').append('<option value="0">Include All</option>');
    // populate subsidiary-list with available subsidiaries
    var records = []
    records.push({ id: -1, name: '' })
    var quarter_id = quarterlist.val()
    for (var i = 0; i < whalewisdom.Subsidiary.subsidiaries.length; i++) {
      var rec = whalewisdom.Subsidiary.subsidiaries[i]
      if (rec.quarter_id == quarter_id) { records.push(rec) }
    }
    if (records.length == 1) {
      subsidiary_list.append('<option value="0">None provided for this quarter</option>')
    } else {
      for (var i = 0; i < records.length; i++) {
        var record = records[i]
        subsidiary_list.append('<option value="' + (record.manager_number == null || record.manager_number == '' ? 'blank' : record.manager_number) + '">' + record.name + '</option>')
      }
    }
  },
  refresh: function (e) {
    if (jQuery('#subsidiary_quarter')[0].selectedIndex <= 0 || jQuery('#subsidiary-list')[0].selectedIndex <= 0) {
      whalewisdom.Utilities.show_alert('Missing Criteria', 'At a minimum select quarter 1 and manager 1 to look at')
      return
    }
    /* if (jQuery('#subsidiary-list2')[0].selectedIndex<=0){
                jQuery("#subsidiaries_table").jqGrid("hideCol", "q2_shares");
                jQuery("#subsidiaries_table").jqGrid("hideCol", "q2_mv");
                jQuery("#subsidiaries_table").jqGrid("hideCol", "shares_change");
                jQuery("#subsidiaries_table").jqGrid("hideCol", "percent_shares_change");
            }
            else{
                jQuery("#subsidiaries_table").jqGrid("showCol", "q2_shares");
                jQuery("#subsidiaries_table").jqGrid("showCol", "q2_mv");
                               jQuery("#subsidiaries_table").jqGrid("showCol", "shares_change");
                               jQuery("#subsidiaries_table").jqGrid("showCol", "percent_shares_change");
            } */
    jQuery('#subsidiaries_table').bootstrapTable('refresh', { url: whalewisdom.Subsidiary.build_url() })
    //    jQuery("#subsidiaries_table").jqGrid('setGridParam', {url: whalewisdom.Subsidiary.build_url()}).trigger("reloadGrid");
  },
  // quarter_id1, quarter_id2, other_manager1, other_manager2, filer_id
  build_url: function () {
    return '/filer/subsidiary_holdings?filer_id=' + whalewisdom.Filer.filer_id +
                '&quarter_id1=' + jQuery('#subsidiary_quarter').val() +
                '&quarter_id2=' + jQuery('#subsidiary_quarter2').val() +
            '&other_manager1=' + jQuery('#subsidiary-list').val() +
                '&other_manager2=' + jQuery('#subsidiary-list2').val() // +
    //  "&type_filter=" + whalewisdom.Filer.build_type_filter() +
    //  "&symbol=" + jQuery('#dt_stock_symbol').val() + "&change_filter=" +
    //  whalewisdom.Filer.build_change_filter() + "&minimum_ranking=" + jQuery('#minimum_ranking').val() +
    //  '&minimum_shares=' + jQuery('#minimum_shares').val()+'&is_etf='+jQuery('#is_etf').val();//+'&'
    // + whalewisdom.Utilities.get_timestamp_cache();
  },
  setup_table: function () {
    whalewisdom.Subsidiary.columns = [
      { field: 'stock_symbol',
        index: 'stock_symbol',
        title: 'Stock',
        formatter: whalewisdom.Subsidiary.symbol_formatter,
        width: '350' },
      { field: 'amount',
        index: 'amount',
        firstsortorder: 'desc',
        title: 'Shares Held',
        formatter: whalewisdom.Filer.format_number },
      { field: 'adjusted_mv',
        index: 'adjusted_mv',
        firstsortorder: 'desc',
        title: 'Market Value',
        formatter: whalewisdom.Filer.format_money },
      { field: 'q2_shares',
        index: 'q2_shares',
        firstsortorder: 'desc',
        title: 'hares Held<br/>Manager 2',
        visible: false,
        formatter: whalewisdom.Filer.format_number },
      { field: 'q2_mv',
        index: 'q2_mv',
        firstsortorder: 'desc',
        visible: false,
        title: 'Market Value<br/>Manager 2',
        formatter: whalewisdom.Filer.format_number },
      { field: 'shares_change',
        firstsortorder: 'desc',
        index: 'shares_change',
        title: 'Difference<br/>in Shares',
        visible: false,
        formatter: whalewisdom.Subsidiary.change_formatter },
      { field: 'percent_shares_change',
        firstsortorder: 'desc',
        index: 'percent_shares_change',
        title: '% Difference',
        visible: false,
        formatter: whalewisdom.Subsidiary.percent_change_formatter }
    ]
    var names = ['Stock', 'Shares Held', 'Market Value', 'Shares Held<br/>Manager 2', 'Market Value<br/>Manager 2', 'Difference<br/>in Shares', '% Difference']
    $('#subsidiaries_table').bootstrapTable({
      url: whalewisdom.Subsidiary.build_url(),
      sidePagination: 'server',
      pagination: true,
      sortName: 'current_ranking',

      sortOrder: 'asc',
      pageSize: 25,
      rowStyle: function (row, index) {
        return {
          css: { 'padding': '8px', 'height': '37px' }
        }
      },
      checkOnInit: true,
      toggle: 'table',
      showColumns: true,
      pageList: [10, 25, 50],
      totalField: 'records',
      columns: whalewisdom.Subsidiary.columns
    })
  },
  export_excel: function () {
    if (!whalewisdom.Utilities.isSubscriber()) {
      whalewisdom.Utilities.show_alert('Subscription Required', 'This feature requires a subscription to use.')
      return
    }
    var url = whalewisdom.Subsidiary.build_url().replace('/filer/subsidiary_holdings', '/filer/subsidiary_holdings_csv')
    window.location = url
  },
  change_formatter: function (cellvalue, record) {
    if (jQuery('#subsidiary-list2')[0].selectedIndex <= 0) { return '' }
    var c = ''
    var desc = Math.abs(record.shares_change)
    desc = whalewisdom.Utilities.round_currency(desc)
    if (!record.shares_change || record.shares_change == 0) {
      desc = 'No Change'
    } else if (record.shares_change < 0) {
      c = 'decreasing'
    } else {
      c = 'increasing'
    }
    return '<span class="' + c + '">' + desc + '</span>'
  },
  percent_change_formatter: function (cellvalue, record) {
    if (jQuery('#subsidiary-list2')[0].selectedIndex <= 0) { return '' }
    var c = ''
    var desc = ''
    // var desc = Math.abs(record.shares_change);
    // desc = whalewisdom.Utilities.round_currency(desc);
    if (record.shares_change == 0) {
      desc = 0
    } else if (record.shares_change == record.q1_shares) {
      desc = ' '// New
    } else if (record.q2_shares && !record.q1_shares) {
      desc = ' '// -100
    } else {
      percent_change = ((record.current_shares - record.previous_shares) / (record.previous_shares)) * 100
      desc = whalewisdom.Utilities.round_currency(percent_change)
    }
    return '<span class="' + c + '">' + desc == 0 ? '' : desc == 'New' ? 'New' : (desc + '%') + '</span>'
  },
  symbol_formatter: function (cellvalue, record) {
    var href = window.location.href.split('/')
    var cell = '<a href="/stock/' + record.stock_permalink + '" title="' + record.stock_name + '">' + record.name + ' - ' + record.stock_symbol.toUpperCase()
    if (record.security_type != 'SH') { cell += "<span style='font-weight:bold;'>(" + record.security_type + ')</span>' }
    cell += '</a>'
    return cell
  }
}
jQuery(function () {
  whalewisdom.Subsidiary.init()
})
